module.exports = __webpack_public_path__ + "img/item4.found.75cb5895.svg";